import { render, staticRenderFns } from "./Rebackfatworas.vue?vue&type=template&id=6e1b218b&"
import script from "./Rebackfatworas.vue?vue&type=script&lang=js&"
export * from "./Rebackfatworas.vue?vue&type=script&lang=js&"
import style0 from "./Rebackfatworas.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/projects/accurate/acc-dashboard/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VSlideXReverseTransition } from 'vuetify/lib'
installComponents(component, {VAlert,VAutocomplete,VBtn,VContainer,VDataTable,VIcon,VPagination,VSlideXReverseTransition})
